import artistic from "../assets/images/artisticbg.png";
import castle from "../assets/images/castle.webp";
import landscape from "../assets/images/landscape.webp";
import streets from "../assets/images/pxfuel.webp";
import retroSpaceTravel from "../assets/images/retro-futuristic-space-travel.jpg";

export const THEME_ARTISTIC = artistic;
export const THEME_CASTLE = castle;
export const THEME_LANDSCAPE = landscape;
export const THEME_STREETS = streets;
export const THEME_RETRO_SPACE_TRAVEL = retroSpaceTravel;